/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SymbolTypeEnum,
    SymbolTypeEnumFromJSON,
    SymbolTypeEnumFromJSONTyped,
    SymbolTypeEnumToJSON,
} from './SymbolTypeEnum';
import {
    TradeTypeEnum,
    TradeTypeEnumFromJSON,
    TradeTypeEnumFromJSONTyped,
    TradeTypeEnumToJSON,
} from './TradeTypeEnum';

/**
 * 
 * @export
 * @interface RealizedBuyTradeDto
 */
export interface RealizedBuyTradeDto {
    /**
     * 
     * @type {SymbolTypeEnum}
     * @memberof RealizedBuyTradeDto
     */
    symbolType: SymbolTypeEnum | null;
    /**
     * 
     * @type {TradeTypeEnum}
     * @memberof RealizedBuyTradeDto
     */
    type: TradeTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof RealizedBuyTradeDto
     */
    sellDate: Date;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    sellTotalPricePortfolioCurrency: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    sellFeesPortfolioCurrency: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    unitPrice: number;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    symbolId: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    symbolName: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    symbolCurrency: string;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    symbolRate: number;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    tradeCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    portfolioCurrency: string;
    /**
     * 
     * @type {Date}
     * @memberof RealizedBuyTradeDto
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    amountAfterSplit: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    totalPricePortfolioCurrency: number;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    tradeSymbolId: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    exchange: string;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    fees: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    feesPortfolioCurrency: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedBuyTradeDto
     */
    rawAmount: number;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    note: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedBuyTradeDto
     */
    brokerName?: string | null;
}

export function RealizedBuyTradeDtoFromJSON(json: any): RealizedBuyTradeDto {
    return RealizedBuyTradeDtoFromJSONTyped(json, false);
}

export function RealizedBuyTradeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealizedBuyTradeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbolType': SymbolTypeEnumFromJSON(json['symbolType']),
        'type': TradeTypeEnumFromJSON(json['type']),
        'sellDate': (new Date(json['sellDate'])),
        'sellTotalPricePortfolioCurrency': json['sellTotalPricePortfolioCurrency'],
        'sellFeesPortfolioCurrency': json['sellFeesPortfolioCurrency'],
        'unitPrice': json['unitPrice'],
        'symbolId': json['symbolId'],
        'symbol': json['symbol'],
        'symbolName': json['symbolName'],
        'symbolCurrency': json['symbolCurrency'],
        'symbolRate': json['symbolRate'],
        'tradeCurrency': json['tradeCurrency'],
        'portfolioCurrency': json['portfolioCurrency'],
        'date': (new Date(json['date'])),
        'amount': json['amount'],
        'amountAfterSplit': json['amountAfterSplit'],
        'totalPricePortfolioCurrency': json['totalPricePortfolioCurrency'],
        'tradeSymbolId': json['tradeSymbolId'],
        'exchange': json['exchange'],
        'fees': json['fees'],
        'feesPortfolioCurrency': json['feesPortfolioCurrency'],
        'rawAmount': json['rawAmount'],
        'note': json['note'],
        'brokerName': !exists(json, 'brokerName') ? undefined : json['brokerName'],
    };
}

export function RealizedBuyTradeDtoToJSON(value?: RealizedBuyTradeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbolType': SymbolTypeEnumToJSON(value.symbolType),
        'type': TradeTypeEnumToJSON(value.type),
        'sellDate': (value.sellDate.toISOString()),
        'sellTotalPricePortfolioCurrency': value.sellTotalPricePortfolioCurrency,
        'sellFeesPortfolioCurrency': value.sellFeesPortfolioCurrency,
        'unitPrice': value.unitPrice,
        'symbolId': value.symbolId,
        'symbol': value.symbol,
        'symbolName': value.symbolName,
        'symbolCurrency': value.symbolCurrency,
        'symbolRate': value.symbolRate,
        'tradeCurrency': value.tradeCurrency,
        'portfolioCurrency': value.portfolioCurrency,
        'date': (value.date.toISOString()),
        'amount': value.amount,
        'amountAfterSplit': value.amountAfterSplit,
        'totalPricePortfolioCurrency': value.totalPricePortfolioCurrency,
        'tradeSymbolId': value.tradeSymbolId,
        'exchange': value.exchange,
        'fees': value.fees,
        'feesPortfolioCurrency': value.feesPortfolioCurrency,
        'rawAmount': value.rawAmount,
        'note': value.note,
        'brokerName': value.brokerName,
    };
}

